import _ from 'underscore';
import getMixin from 'underscore.get';
_.mixin(getMixin);

/**
 * @module Store/view
 * @description Module for filters
*/


/**
 * @constant State of orders store
 * @type {object}
* */
const state = {
    filters: {
        'name': '',
        'type': ''
    },
    sortOrder: {
        field: 'name',
        direction: 'asc'
    },
    filtredProducts: []
};

/**
 * @constant Getters
 * @type {object}
**/

const getters = {
    getProductsTableFilters: state => state.filters,
    getProductsTableSortOrder: state => state.sortOrder,
    getProductsIncludingFilters: state => state.filtredShops
};

/**
 * @constant Mutations
 * @type {object}
**/


const mutations = {
    addProductsTableFilters: (state, filters) => state.filters = filters,
    setProductsTableSortOrder: (state, sortOrder) => state.sortOrder = sortOrder,
    setProductsIncludingFilters: (state, filtredShops) => state.filtredShops = filtredShops
};

/**
 * @constant Actions
 * @type {object}
**/


const actions = {
    async AddProductsTableFilters ({commit}, filters) {
        commit('addProductsTableFilters', filters);
    },
    async SetProductsTableSortOrder ({commit}, sortOrder) {
        commit('setProductsTableSortOrder', sortOrder);
    },
    SetProductsIncludingFilters ({ commit, state }, data) {
        const { filters } = state;
        let filteredResult = data;
        if(data.length > 0){
            _.each(Object.values(filters), filter =>{
                if(filter.hasOwnProperty('value')){
                    filteredResult = _.filter(filteredResult, single => {
                        if(filter.value !== ''){
                            return _.get(single, filter.field).toLowerCase().indexOf(filter.value.toLowerCase()) > -1;
                        }else{
                            return true;
                        }
                    });
                }
            });
        }
        commit('setProductsIncludingFilters', filteredResult );
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
